module.exports = __webpack_public_path__ + "static/sketch-prototyping@2x-a125ffd4fd5b739ace4ec4e7237b617e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/sketch-prototyping@2x.jpg
// module id = 451
// module chunks = 131293461488081 145262073310797 281043220932899